module.exports = __webpack_public_path__ + "img/1102454157.990125c9.jpg";